import React from "react";
import { ActivityIndicator, ActivityIndicatorProps } from "react-native";
import { useTheme } from "@ui-kitten/components";

type LoadingSpinnerType = Omit<ActivityIndicatorProps, "color">;

const LoadingSpinner: React.FC<LoadingSpinnerType> = (props) => {
    const theme = useTheme();
    return <ActivityIndicator {...props} color={theme["color-info-500"]} />;
};
export default LoadingSpinner;
